import swal from "sweetalert";
export const sweetAlertError = (message, title = 'Error') => swal({
    title: title,
    text: message,
    icon: 'error'
});
export const sweetAlertTimedSuccess = (params) => sweetAlert({
    icon: 'success',
    title: 'Success',
    timer: 2000,
    ...params
});
